// frontend/src/pages/ChatterDashboard.js
import React from 'react';
import Conversations from '../components/Conversations';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function ChatterDashboard() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
      await logout();
      navigate('/login');
  };

  return (
    <div style={{ height: '100vh', background: '#1e1e1e', color: '#ccc', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2>💬 Chatter Dashboard</h2>
            <button onClick={handleLogout} style={{ background: '#a31515', color: 'white', border: 'none', padding: '5px 10px' }}>Logout</button>
        </div>
        
        <div style={{ background: '#252526', padding: '20px', borderRadius: '8px' }}>
            <p>Welcome, <strong>{currentUser?.email}</strong></p>
            {/* Assigned Models text removed as requested */}
            <hr style={{ borderColor: '#444', margin: '20px 0' }} />
        </div>

        {/* Conversation List Area */}
        <div style={{ flex: 1, marginTop: '20px', background: '#252526', borderRadius: '8px', overflow: 'hidden' }}>
            <Conversations role="chatter" />
        </div>
    </div>
  );
}